export const RAF_TYPES = {
  ONCE_OFF_PAYMENTS: 'ONCE_OFF_PAYMENTS',
  REDUCE_COMMISSIONS: 'REDUCE_COMMISSIONS',
};

export const REFERRAL_EARNINGS_WITHDRAWAL_MODAL = 'REFERRAL_EARNINGS_WITHDRAWAL_MODAL';
export const REFERRAL_EARNINGS_WITHDRAWAL_MODAL_FORM = 'REFERRAL_EARNINGS_WITHDRAWAL_MODAL_FORM';

export const REFERRAL_STATUS = {
  NOT_TRADED: 'not_traded',
  VERIFYING: 'verifying',
};

export const CHANGE_PROGRAM_MODAL = 'CHANGE_PROGRAM_MODAL';

export const CHANGE_PROGRAM_FORM = 'CHANGE_PROGRAM_FORM';

export const PROGRAM_OPTIONS = [
  {
    label: 'Once Off Payments',
    value: RAF_TYPES.ONCE_OFF_PAYMENTS,
  },
  {
    label: 'Reduced Commissions',
    value: RAF_TYPES.REDUCE_COMMISSIONS,
  },
];
